import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const getDefaultState = () => {
  return {
    api_baseurl: 'https://api.no-foodloss.jp/',
    img_baseurl: 'https://no-foodloss.jp/',
    post_headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    user_info: {},
    operation_type: 0,
    category_list: []  // 配列に変更
  };
};

export default createStore({
  state: getDefaultState(),
  getters: {
  },
  mutations: {
    set_pre_user_info(state, val) {
      state.user_info.pre_user_id = val
    },
    set_user_info(state, val) {
      state.user_info.user_id = val
    },
    set_category_list(state, val) {
      state.category_list = val
    },
    set_operation_type(state, val) {
      state.operation_type = val
    },
    setOperationType(state, val) {
      state.operation_type = val;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      key: 'no-foodloss',
      paths: [
        'user_info',
        'category_list'
      ],
      storage: window.localStorage,
    })
  ]
})
